import { createI18n, type I18nOptions } from 'vue-i18n'
import { datetimeFormats, numberFormats } from '@/i18n/formats'
import de from '@/i18n/locales/de.json'

const CONFIG = {
  legacy: false,
  locale: 'de',
  fallbackLocale: 'de',
  globalInjection: true,
  messages: {
    de,
  },
  datetimeFormats: datetimeFormats,
  numberFormats: numberFormats,
} satisfies I18nOptions

export const i18n = createI18n(CONFIG)
export default defineI18nConfig(() => CONFIG)
